import React, { Component } from 'react'

import * as selectors from 'modules/settings/selectors'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import * as actions from 'modules/settings/actions'

import { Input, Toggle } from '@driftt/tide'
import cx from 'classnames'

import './style.css'

class AdvancedSettings extends Component {
  
  constructor(props) {
    super(props)
    
    this.state = {
      validGoogleAnalyticsCode: !!props.settings.googleAnalyticsCode,
      gaCode: props.settings.googleAnalyticsCode || ''
    }
  }
  
  handleGoogleAnalyticsCodeChange = event => {
    const input = event.target.value
    const validGoogleAnalyticsCode = (/^ua-\d{4,9}-\d{1,4}$/i).test(input)
    
    this.setState({
      validGoogleAnalyticsCode: validGoogleAnalyticsCode,
      gaCode: input
    }, this.sendCode)
  }
  
  handleNoIndexToggleChange = () => this.props.updateKBNoIndex(!this.props.settings.isKBIndexed)
  
  sendCode = () => {
    const { gaCode } = this.state
    this.props.setGoogleAnalyticsCode(gaCode)
  }
  
  render() {
    const { settings } = this.props
    return (
      <div className="basic-settings-wrapper advanced-wrapper">
        <fieldset>
          <Input
            label="Google Analytics Tracking ID"
            description="Add your Tracking ID to start tracking your Drift Help web traffic."
            className={cx('google-analytics-input', {
              'error': () => {}
            })}
            value={settings.googleAnalyticsCode ? settings.googleAnalyticsCode : this.state.gaCode}
            placeholder={"e.g. UA-XXXXXX-X"}
            onChange={this.handleGoogleAnalyticsCodeChange}
          />
        </fieldset>
  
        <div className="no-index-wrapper">
          <p className="no-index-primary-text">Allow Drift Help to be indexed</p>
          <p className="no-index-secondary-text">When this is enabled, customers will be able to find your help articles from search providers like Google, Yahoo, Bing etc.</p>
          <Toggle
            className="settings-drift-help-index-toggle"
            checked={settings.isKBIndexed}
            onChange={this.handleNoIndexToggleChange}
          />
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  settings: selectors.getSettings(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    setGoogleAnalyticsCode: actions.setGoogleAnalyticsCode,
    updateKBNoIndex: actions.updateKBNoIndex
  }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedSettings)